import { toast } from 'react-toastify';

export const findIndex = (arr, type) => {
    let index = arr.findIndex(x => x[type])
    return index;
}

export const filterCaseInsensitive = (filter, row) => {
    const id = filter.pivotId || filter.id;
    if (row[id] !== null) {
        if (isNaN(row[id])) {
            return (
                row[id] !== undefined ?
                    String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase())
                    :
                    true
            );
        } else {
            return (
                row[id] !== undefined ?
                    String(row[id]).startsWith(filter.value)
                    :
                    true
            );
        }
    }
};

export const notify = (type, msg) => {
    toast[type](msg, {
        position: toast.POSITION.TOP_RIGHT
    });
}

export function nullCheck(data) {
    var tempData = data !== null && data !== undefined && typeof data === 'string' ? data.toLowerCase() : data
    return (tempData === null || tempData === "null" || tempData === 0 || tempData === undefined || tempData === "undefined" ? "-" : "" + data)
}

export function removeNonASCII(str) {
    // eslint-disable-next-line
    return str.replace(/[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g, '');
}

export function checkEvenOdd(num) {
    return num % 2;
}

export const NumberString = (value) => {
    var numbers = /^[0-9]+$/;
    if (value !== undefined) {
        if (value.match(numbers)) {
            return true;
        }
        else {
            return false;
        }
    }
}

export const checkImage = (imageSrc) => {
    var image = new Image();
    image.src = imageSrc;
    if (image.width === 0) {
        return false;
    } else {
        return true;
    }
}

export const arraysEqual = (_arr1, _arr2) => {
    if (!Array.isArray(_arr1) || !Array.isArray(_arr2) || _arr1.length !== _arr2.length)
        return false;
    var arr1 = _arr1.concat().sort();
    var arr2 = _arr2.concat().sort();
    for (var i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i])
            return false;
    }
    return true;
}

export const calculateBubbleGraphSize = (num, numLength) => {
    let DivisionNumber = 0
    if (numLength <= 2) {
        DivisionNumber = 0
    } else if (numLength > 2 && numLength <= 10) {
        DivisionNumber = numLength - 2.5
    } else {
        DivisionNumber = numLength - 2
    }
    let divisionValue = Math.pow(10, DivisionNumber)
    let size = Math.round(num) / divisionValue
    let ActualSize = Math.round(size)
    return ActualSize;
}

export const checkForBlank = (val) => {
    if (val === 0 || val === '0' || val === '-1' || val === -1 || val === "" || val === "NA" || val === "N,A" || val === "na" || val === undefined || val === null || val === 'null' || val === 'null:null' || val === '1000-01-01') {
        return false;
    } else {
        return true;
    }
}

export const replaceNull = (val) => {
    return val.toString().replace(/null,/g, '').replace(/,null/g, '').replace(/, null/g, '')
}

export const insertSpaceAfterComma = (val) => {
    return val.replace(/,/g, ', ')
}

export const NumberFormat = (value) => {
    if (value !== undefined && value !== '' && value != null) {
        if (isNaN(value)) {
            return value
        } else {
            return Math.round(Number(value)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
    else {
        return '-';
    }
}

export const insertSpaces = (string) => {
    string = string.replace(/([a-z])([A-Z])/g, '$1 $2');
    string = string.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    return string;
}

export const removeSpace = (string) => {
    if (string !== undefined)
        string = string.replace(/ /g, '').replace(/[&\\#,+()$~%.'":*?<>{}]/g, '')
    return string;
}

export const resizableGrid = () => {
    var row = document.getElementById('resizeTr'),
        cols = row ? row.children : undefined;
    if (!cols) return;
    for (var i = 0; i < cols.length; i++) {
        var div = createDiv(row.offsetHeight);
        cols[i].appendChild(div);
        cols[i].style.position = 'relative';
        setListeners(div);
    }
}

export const createDiv = (height) => {
    var div = document.createElement('div');
    div.style.top = 0;
    div.style.right = '-2.5px';
    div.style.width = '5px';
    div.style.position = 'absolute';
    div.style.cursor = 'col-resize';
    div.style.backgroundColor = '#ccc';
    div.style.userSelect = 'none';
    div.style.height = height + 'px';
    return div;
}

export const setListeners = (div) => {
    var pageX, curCol, nxtCol, curColWidth, nxtColWidth;
    div.addEventListener('mousedown', function (e) {
        curCol = e.target.parentElement;
        nxtCol = curCol.nextElementSibling;
        pageX = e.pageX;
        curColWidth = curCol.offsetWidth
        if (nxtCol)
            nxtColWidth = nxtCol.offsetWidth
    });

    document.addEventListener('mousemove', function (e) {
        if (curCol) {
            var diffX = e.pageX - pageX;
            if (nxtCol)
                nxtCol.style.width = (nxtColWidth - (diffX)) + 'px';
            curCol.style.minWidth = (curColWidth + diffX) + 'px';
        }
    });

    document.addEventListener('mouseup', function (e) {
        curCol = undefined;
        nxtCol = undefined;
        pageX = undefined;
        nxtColWidth = undefined;
        curColWidth = undefined;
    });
}

export const millionConvertor = (labelValue) => {
    var regex = /\d+/g;
    var numberForConvert = labelValue.match(regex).join()
    // Nine Zeroes for Billions
    // if (labelValue.match(numbers)) {
    return Math.abs(Number(numberForConvert)) >= 1.0e+9
        ? "$" + Math.abs(Number(numberForConvert)) / 1.0e+9 + "B"
        // Six Zeroes for Millions 
        : "$" + Math.abs(Number(numberForConvert)) >= 1.0e+6
            ? "$" + Math.abs(Number(numberForConvert)) / 1.0e+6 + "M"
            // Three Zeroes for Thousands
            : "$" + Math.abs(Number(numberForConvert)) >= 1.0e+3
                ? "$" + Math.abs(Number(numberForConvert)) / 1.0e+3 + "K"
                : "$" + Math.abs(Number(numberForConvert));
    // } else {
    //     return labelValue;
    // }

}

export const dragElement = (elmnt) => {
    var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    if (document.getElementById(elmnt.id + "header")) {
        document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
    } else {
        elmnt.onmousedown = dragMouseDown;
    }

    if (document.getElementById(elmnt.id + "body")) {
        document.getElementById(elmnt.id + "body").onmousedown = dragMouseDown;
    } else {
        elmnt.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
        elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }

    function closeDragElement() {
        document.onmouseup = null;
        document.onmousemove = null;
    }
}

export const d3TreemapData = (mapName, cat1, cat2, cat3, cat4, dataForTree) => {
    if (dataForTree.length > 0) {
        if (dataForTree[0][cat1] !== undefined) {
            let catChildrens = { name: mapName, children: [], key: '' }
            dataForTree.forEach(element => {
                if (catChildrens.children.filter(x => x.name === element[cat1]).length <= 0) {
                    catChildrens.children.push({ name: element[cat1], children: [], key: cat1 })
                }
            });
            dataForTree.forEach(element => {
                catChildrens.children.forEach(cat => {
                    if (cat.name === element[cat1]) {
                        if (cat.children.filter(x => x.name === element[cat2]).length <= 0) {
                            cat.children.push({ name: element[cat2], children: [], key: cat2 })
                        }
                    }
                })
            });
            dataForTree.forEach(element => {
                catChildrens.children.forEach(cat => {
                    if (element[cat1] === cat.name) {
                        cat.children.forEach(sent => {
                            if (element[cat2] === sent.name) {
                                if (sent.children.filter(x => x.name === element[cat3]).length <= 0) {
                                    sent.children.push({ name: element[cat3], children: [], key: cat3 })
                                }
                            }
                        })
                    }
                })
            })
            dataForTree.forEach(element => {
                catChildrens.children.forEach(cat => {
                    if (element[cat1] === cat.name) {
                        cat.children.forEach(sent => {
                            if (element[cat2] === sent.name) {
                                sent.children.forEach(signal => {
                                    if (element[cat3] === signal.name) {
                                        if (signal.children.filter(x => x.name === element[cat4]).length <= 0) {
                                            signal.children.push({ name: element[cat4], value: 1, key: cat4 })
                                        }
                                    }
                                })
                            }
                        })
                    }
                })
            })
            return catChildrens;
        }
    }
}


export const csvDataToJson = (data) => {
    let finalData = []
    let finalJsonObj = {}
    if(data.length > 0){
        data.forEach((row, i) => {
            if(i === 0 || row.length !== data[0].length){

            } else {
                row.forEach((column, j) => {
                    finalJsonObj[data[0][j]] = column
                })
                finalData.push(finalJsonObj)
            }
            finalJsonObj = {}
        })
        return finalData;
    }
}